import React from 'react';
export function ClosingManifesto() {
  return <section className="w-full bg-white py-16 md:py-24 px-4 text-center" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <div className="text-xl md:text-2xl font-bold text-brand-blue mb-6" data-id="element-66">
          🩺 MÉDICO EN PROCESO™
        </div>
        <h2 className="text-2xl md:text-4xl font-bold text-slate-900 mb-10 leading-tight" data-id="element-67">
          El sistema N°1 para estudiantes de Medicina en Argentina que quieren
          organizar su carrera, estudiar con método y aprobar sin improvisar.
        </h2>
        <div className="max-w-3xl mx-auto" data-id="element-68">
          <p className="text-xl md:text-3xl italic text-brand-blue font-medium leading-relaxed" data-id="element-69">
            "Porque avanzar en Medicina no debería costarte todas tus noches y
            todos tus fines de semana."
          </p>
        </div>
      </div>
    </section>;
}